<div class="dashboard-menu">
  <nav>
    <ul>
      <li><a [routerLinkActive]="['active']" routerLink="/painel-filas-de-atendimento" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Geral</a></li>
      <li><a [routerLinkActive]="['active']" routerLink="/painel-filas-de-atendimento/distribuicao-por-fila">Distribuição por fila</a></li>
      <li class="disabled"><a>Distribuição por corretor</a></li>
      <li class="disabled"><a>Leads represados</a></li>
    </ul>
  </nav>
  <router-outlet></router-outlet>
</div>